import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import {API_URL} from "../constants.js";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const stripHtml = (html) => {
    if (!html) {
        return '';
    }
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
};

export function EditBlueRemarks(props) {
    const {t} = useTranslation();
    const name = useRef();
    const sortOrder = useRef();
    const [disabled, setDisabled] = useState(0);
    const [blueRemark, setBlueRemark] = useState({});
    const [description, setDescription] = useState('');
    const [isActive, setIsActive] = useState(true);
    const id = props.match.params.id;

    useEffect(() => {
        axios.get(API_URL + 'blue-remarks/' + id).then((response) => {
            if (response.data.status) {
                const data = response.data.data;
                setBlueRemark(data);
                setDescription(stripHtml(data.description));
                setIsActive(!!data.is_active);
            } else {
                alertify.error(response.data.message);
            }
        }).catch(() => {
            alertify.error("Something went wrong. Try again!");
        });
    }, [id]);

    const updateBlueRemarksHandler = (e) => {
        e.preventDefault();
        setDisabled(1);
        axios.post(API_URL + "blue-remarks/update", {
            id: blueRemark.id,
            name: name.current.value,
            description: description,
            sort_order: sortOrder.current.value || 0,
            is_active: isActive,
        }).then((response) => {
            setDisabled(0);
            if (response.data.status) {
                alertify.success(response.data.message);
                props.history.push("/blue-remarks/list");
            } else {
                alertify.error(response.data.message);
            }
        }).catch(() => {
            setDisabled(0);
            alertify.error("Something went wrong. Try again!");
        });
    };

    return (
        <Row>
            <Col md={12}>
                <Card>
                    <CardHeader title={t("Edit Blue Remark")}>
                        <CardHeaderToolbar>
                            <Link to="/blue-remarks/list" className="btn btn-primary btn-sm mx-3">
                                {t("Blue Remarks List")}
                            </Link>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>
                        <div className="mt-5">
                            <Form onSubmit={updateBlueRemarksHandler}>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Name")}</Form.Label>
                                        <Form.Control ref={name} placeholder={t("Enter Blue Remark Name")}
                                                      defaultValue={blueRemark.name}/>
                                    </Form.Group>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Sort Order")}</Form.Label>
                                        <Form.Control ref={sortOrder} type="number"
                                                      defaultValue={blueRemark.sort_order || 0}/>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Description")}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            placeholder={t("Enter Description")}
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Check
                                            type="checkbox"
                                            id="is_active_edit"
                                            label={t("Active")}
                                            checked={isActive}
                                            onChange={(e) => setIsActive(e.target.checked)}
                                        />
                                    </Form.Group>
                                </Form.Row>
                                <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                    {t("Save")}
                                    <span
                                        dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                </Button>
                            </Form>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
}
